// components/Sidebar.jsx
import { useEffect, useState } from "react";
import tovLogo from "../assets/tov.jpg";
import api from '../config/api';

export default function Sidebar() {
  const [role, setRole] = useState("");

  useEffect(() => {
    if (window.Menu && document.getElementById("layout-menu")) {
      new window.Menu(document.getElementById("layout-menu"));
    }

    const token = localStorage.getItem("token");
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setRole(payload.role);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const canAccess = (roles) => roles.includes(role);

  return (
    <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
      <div className="app-brand demo" style={{ paddingTop: "1.5rem" }}>
        <a href="/" className="app-brand-link">
          <span className="app-brand-logo demo">
            <img
              src={tovLogo}
              alt="TOV Logo"
              style={{ maxWidth: "50px", height: "50px", borderRadius: "50%" }}
            />
          </span>
          <span className="app-brand-text demo menu-text fw-semibold ms-2">The Ocean Views</span>
        </a>

        <a href="#" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
          <i className="bx bx-chevron-left bx-sm align-middle"></i>
        </a>
      </div>

      <ul className="menu-inner py-1 mt-4" style={{ gap: "0.25rem" }}>
        {role === "admin" && (
          <li className="menu-item">
            <a href="#" className="menu-link menu-toggle">
              <i className="menu-icon tf-icons bx bx-user-circle"></i>
              <div className="fw-normal">User Management</div>
            </a>
            <ul className="menu-sub">
              <li className="menu-item">
                <a href="/user_management" className="menu-link">
                  <div className="fw-normal">Manage Users</div>
                </a>
              </li>
            </ul>
          </li>
        )}

        {canAccess(["admin", "finance-staff", "accountant"]) && (
          <li className="menu-item">
            <a href="#" className="menu-link menu-toggle">
              <i className="menu-icon tf-icons bx bx-transfer-alt"></i>
              <div className="fw-normal">Finance Transactions</div>
            </a>
            <ul className="menu-sub">
              <li className="menu-item">
                <a href="/account_codes" className="menu-link">
                  <div className="fw-normal">Account Code Management</div>
                </a>
              </li>
              <li className="menu-item">
                <a href="/transactions" className="menu-link">
                  <div className="fw-normal">All Transactions</div>
                </a>
              </li>
              <li className="menu-item">
                <a href="/import_journal" className="menu-link">
                  <div className="fw-normal">Import Journal</div>
                </a>
              </li>
            </ul>
          </li>
        )}

        {canAccess(["admin", "finance-staff", "accountant"]) && (
          <li className="menu-item">
            <a href="#" className="menu-link menu-toggle">
              <i className="menu-icon tf-icons bx bx-bar-chart-alt-2"></i>
              <div className="fw-normal">Finance Reports</div>
            </a>
            <ul className="menu-sub">
              <li className="menu-item">
                <a href="/journal_reports" className="menu-link">
                  <div className="fw-normal">Journal</div>
                </a>
              </li>
              <li className="menu-item">
                <a href="/ledger_reports" className="menu-link">
                  <div className="fw-normal">Ledger</div>
                </a>
              </li>
              <li className="menu-item">
                <a href="/income_statements" className="menu-link">
                  <div className="fw-normal">Income Statement</div>
                </a>
              </li>
            </ul>
          </li>
        )}

        {canAccess(["admin", "storage-staff", "accountant"]) && (
          <li className="menu-item">
            <a href="#" className="menu-link menu-toggle">
              <i className="menu-icon tf-icons bx bx-box"></i>
              <div className="fw-normal">Storage Transactions</div>
            </a>
            <ul className="menu-sub">
              <li className="menu-item">
                <a href="/storage_items" className="menu-link">
                  <div className="fw-normal">Item Type Management</div>
                </a>
              </li>
              <li className="menu-item">
                <a href="/storage_transactions" className="menu-link">
                  <div className="fw-normal">All Transactions</div>
                </a>
              </li>
            </ul>
          </li>
        )}

        {canAccess(["admin", "storage-staff", "accountant"]) && (
          <li className="menu-item">
            <a href="/villas" className="menu-link">
              <i className="menu-icon tf-icons bx bx-home"></i>
              <div className="fw-normal">Villas</div>
            </a>
          </li>
        )}

        <li className="menu-item">
          <a href="#" className="menu-link" onClick={handleLogout}>
            <i className="menu-icon tf-icons bx bx-power-off"></i>
            <div className="fw-normal">Logout</div>
          </a>
        </li>
      </ul>
    </aside>
  );
}
